export const environment = {
  // enable Production mode
  production: false,
  // API base URL
  apiUrl: 'https://godata.cempi.saude.sc.gov.br/backend/api',
  // log messages on server?
  enableApiLogging: false,
  // log messages in browser's console?
  enableClientLogging: false
};
